import { Pagination } from '@chr/eds-react';
import { gridPageCountSelector, gridPageSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';

export const DataGridPagination = () => {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    
    const onPageChange = (event: any, page: number) => {
        // doing page - 1 because datagrid has 0 based index
        apiRef.current.setPage(page - 1)
    }

    return (<Pagination page={page + 1} onChange={onPageChange} totalPages={pageCount} />);
}

export default DataGridPagination;